import Empty from '@/views/Empty';
// import ProfileIndex from '@/views/pages/profile/Index';
import ProfileDetail from '@/views/pages/profile/Detail';
import ProfilePreview from '@/views/pages/profile/detail/Preview';
import ProfileUpdatePassword from '@/views/pages/profile/detail/UpdatePassword';

export default {
  path: 'profile',
  component: Empty,
  children: [
    // {
    //   path: '',
    //   name: 'Profile',
    //   component: ProfileIndex,
    // },
    {
      path: '',
      component: ProfileDetail,
      children: [
        {
          path: '',
          name: 'Profile Preview',
          component: ProfilePreview,
        },
        {
          path: 'update_password',
          name: 'Update Password',
          component: ProfileUpdatePassword,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/profile.js